<div class="dashboard-page" *ngIf="data">

  <!-- ====================================================== -->
  <!-- PAGE HEADER -->
  <!-- ====================================================== -->

  <div class="dashboard-header-row">
    <div class="dashboard-header-text">
      <h1 class="dashboard-page-title">
        Admin Dashboard
      </h1>

      <p class="dashboard-page-subtitle">
        Live statistics from the Workplace Safety Plan Builder
      </p>
    </div>

    <div class="dashboard-header-action">
      <button type="button" class="ontario-button ontario-button--primary dashboard-download-btn"
        (click)="downloadExcel()">
        Download Excel
      </button>
    </div>
  </div>


  <!-- ====================================================== -->
  <!-- SUMMARY CARDS -->
  <!-- ====================================================== -->

  <div class="summary-grid">

    <div class="summary-card">
      <div class="summary-icon users-icon">
        👥
      </div>

      <div class="summary-content">
        <div class="summary-number">
          {{ data.registeredUsers || 0 }}
        </div>

        <div class="summary-label">
          Total Registered Users
        </div>
      </div>
    </div>


    <div class="summary-card">
      <div class="summary-icon created-icon">
        📄
      </div>

      <div class="summary-content">
        <div class="summary-number">
          {{ data.safetyPlansCreated || 0 }}
        </div>

        <div class="summary-label">
          Total Safety Plans Created
        </div>
      </div>
    </div>


    <div class="summary-card">
      <div class="summary-icon completed-icon">
        ✔
      </div>

      <div class="summary-content">
        <div class="summary-number">
          {{ data.completedSafetyPlans || 0 }}
        </div>

        <div class="summary-label">
          Total Safety Plans Completed
        </div>
      </div>
    </div>


    <div class="summary-card">
      <div class="summary-icon business-icon">
        🏢
      </div>

      <div class="summary-content">
        <div class="summary-number">
          {{ data.totalBusinessesWithCompletedSafetyPlans || 0 }}
        </div>

        <div class="summary-label">
          Businesses with Completed Safety Plans
        </div>
      </div>
    </div>

  </div>


  <!-- ====================================================== -->
  <!-- TOP ROW -->
  <!-- BUSINESS USERS BY SECTOR + BUSINESS SIZE / REGION -->
  <!-- ====================================================== -->

  <div class="dashboard-grid two-column-grid">

    <!-- ================================================== -->
    <!-- BUSINESS USERS BY SECTOR -->
    <!-- ================================================== -->

    <div class="dashboard-card">

      <h2 class="dashboard-card-title">
        Business Users by Sector
      </h2>

      <div class="table-container">

        <table class="ontario-table ontario-table--zebra sector-table">

          <thead>
            <tr>
              <th>
                Sector
              </th>

              <th class="number-cell">
                Number Of Businesses
              </th>

              <th class="number-cell">
                % of Total Businesses
              </th>
            </tr>
          </thead>


          <tbody>

            <tr *ngFor="let s of usersBySector">
              <td>
                {{ s.sector }}
              </td>

              <td class="number-cell">
                {{ s.count }}
              </td>

              <td class="number-cell">
                {{ s.percentage }}%
              </td>
            </tr>


            <tr class="total-row">
              <th>
                Total
              </th>

              <th class="number-cell">
                {{ data.registeredUsers || 0 }}
              </th>

              <th class="number-cell">
                100%
              </th>
            </tr>

          </tbody>

        </table>

      </div>

    </div>

    <!-- ================================================== -->
    <!-- WORKER TYPES -->
    <!-- ================================================== -->

    <div class="dashboard-card">
      <h2 class="dashboard-card-title">
        Worker Types by Sector for all Registered Users
      </h2>

      <div class="table-container">
        <table class="ontario-table ontario-table--zebra worker-table">
          <thead>
            <tr>
              <th>
                Sector
              </th>
              <th class="number-cell">
                Part-time / Casual / Seasonal
              </th>
              <th class="number-cell">
                Youth (Under 25)
              </th>
              <th class="number-cell">
                Contract Foreign Workers
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let w of workerTypesRows">
              <td>
                {{ w.sector }}
              </td>
              <td class="number-cell">
                {{ w.partTimeCasualSeasonal }}
              </td>
              <td class="number-cell">
                {{ w.under25Workers }}
              </td>
              <td class="number-cell">
                {{ w.foreignWorkers }}
              </td>
            </tr>

            <tr class="total-row">
              <th>
                Total
              </th>
              <th class="number-cell">
                {{ workerTypesTotals.partTimeCasualSeasonal }}
              </th>
              <th class="number-cell">
                {{ workerTypesTotals.under25Workers }}
              </th>
              <th class="number-cell">
                {{ workerTypesTotals.foreignWorkers }}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>


  <!-- ====================================================== -->
  <!-- SECOND ROW -->
  <!-- WORKER TYPES + COMPLETED SAFETY PLANS BY HAZARD -->
  <!-- ====================================================== -->
  <div class="dashboard-grid two-column-grid">

    <!-- ================================================== -->
    <!-- BUSINESS SIZE / REGION / SECTOR -->
    <!-- ================================================== -->
    <div class="dashboard-card">
      <h2 class="dashboard-card-title">
        Business Size and Number of Locations by Region for All Registered Users
      </h2>

      <div class="table-container">
        <table class="ontario-table ontario-table--zebra region-matrix-table">
          <thead>
            <tr>
              <th>
                Sector
              </th>
              <th>
                Business Size
              </th>
              <th class="number-cell">
                Central East
              </th>
              <th class="number-cell">
                Central West
              </th>
              <th class="number-cell">
                East
              </th>
              <th class="number-cell">
                North
              </th>
              <th class="number-cell">
                West
              </th>
              <th class="number-cell">
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let r of regionMatrixRows">
              <td>
                {{ r.sector }}
              </td>
              <td>
                {{ r.businessSize }}
              </td>
              <td class="number-cell">
                {{ r.centralEast }}
              </td>
              <td class="number-cell">
                {{ r.centralWest }}
              </td>
              <td class="number-cell">
                {{ r.east }}
              </td>
              <td class="number-cell">
                {{ r.north }}
              </td>
              <td class="number-cell">
                {{ r.west }}
              </td>
              <td class="number-cell total-count">
                {{ r.total }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ================================================== -->
    <!-- BUSINESSES WITH COMPLETED SAFETY PLANS BY HAZARD -->
    <!-- ================================================== -->
    <div class="dashboard-card">

      <h2 class="dashboard-card-title">
        Businesses with Completed Safety Plans by Hazard
      </h2>

      <div class="table-container">

        <table class="ontario-table ontario-table--zebra completed-table">

          <thead>
            <tr>

              <th>
                Hazard
              </th>

              <th>
                Hazard Type
              </th>

              <th class="number-cell">
                Total Businesses with Completed Safety Plans
              </th>

            </tr>
          </thead>


          <tbody>

            <tr *ngFor="let h of businessesWithCompletedPlansByHazard">

              <td>
                {{ h.hazard }}
              </td>

              <td>
                {{ h.typeOfHazard }}
              </td>

              <td class="number-cell">
                {{ h.count }}
              </td>

            </tr>


            <!-- <tr class="total-row">

              <th>
                Total Unique Businesses
              </th>

              <th></th>

              <th class="number-cell">
                {{ data.totalBusinessesWithCompletedSafetyPlans || 0 }}
              </th>

            </tr> -->

          </tbody>

        </table>

      </div>

    </div>
  </div>


  <!-- ====================================================== -->
  <!-- THIRD ROW -->
  <!-- HAZARDS SELECTED -->
  <!-- ====================================================== -->
  <div class="dashboard-grid two-column-grid">

    <!-- ================================================== -->
    <!-- SECTION 6 -->
    <!-- Businesses and their selected Designated Substances -->
    <!-- ================================================== -->
    <div class="dashboard-card">
      <h2 class="dashboard-card-title">
        Businesses and their selected Designated Substances
      </h2>
      <div class="table-container">
        <table class="ontario-table ontario-table--zebra region-matrix-table">

          <thead>
            <tr>
              <th>
                Designated Substance
              </th>
              <th class="number-cell">
                Total Businesses who selected these Designated Substances
                in their profile page
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ds of businessesByDesignatedSubstance">
              <td>
                {{ ds.designatedSubstance }}
              </td>
              <td class="number-cell">
                {{ ds.businessCount }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- ================================================== -->
    <!-- How many Business have completed these hazard in their hazard card page ? -->
    <!-- ================================================== -->
    <div class="dashboard-card">

      <h2 class="dashboard-card-title">
        Businesses and their completed Hazards
      </h2>

      <div class="table-container">

        <table class="ontario-table ontario-table--zebra completed-table">

          <thead>
            <tr>

              <th>
                Hazard
              </th>

              <th>
                Hazard Type
              </th>

              <th class="number-cell">
                Total Businesses who completed these hazards in their hazard card page
              </th>

            </tr>
          </thead>


          <tbody>

            <tr *ngFor="let h of totalCompletedHazardsList">

              <td>
                {{ h.hazard }}
              </td>

              <td>
                {{ h.typeOfHazard }}
              </td>

              <td class="number-cell">
                {{ h.count }}
              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>
  </div>
</div>